<form (ngSubmit)="onSubmit()" [formGroup]="formGroup" nz-form  nz-row [nzLayout]="'vertical'" [nzGutter]="8" style="margin-bottom: 10px;">
    <app-search-field nz-col [nzXl]="6" [nzSpan]="12" *ngFor="let field of searchSection" [formCtrl]="formGroup.get(field.key)" [field]="field"></app-search-field>
    <div class="search-form-btn-wrapper" nz-col [nzXl]="6" [nzSpan]="12" nzAlign="middle">
        <button class="search-btn" type="submit" nz-button nzType="primary">Search</button>
    </div>
</form>